import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7bdda6f7&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=7bdda6f7&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bdda6f7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Workplace\\vueProject\\edu_aim\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7bdda6f7')) {
      api.createRecord('7bdda6f7', component.options)
    } else {
      api.reload('7bdda6f7', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7bdda6f7&scoped=true", function () {
      api.rerender('7bdda6f7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/mine/index.vue"
export default component.exports